import lb from '@/lib/loopback';

export function deleteFile(file) {
  return lb
    .delete(`/containers/centro-de-memorias/files/${encodeURIComponent(file)}`);
}

export function downloadFile(file) {
  return lb
    .get(`/containers/centro-de-memorias/download/${file}`);
}

export function uploadFile(file) {
  return lb
    .post('/containers/centro-de-memorias/upload', file);
}

export function getFile(file) {
  return lb
    .get(`/containers/centro-de-memorias/files/${file}`);
}

export const baseURL = `${lb.defaults.baseURL}/containers/centro-de-memorias`;
export const awsURL = 'https://centro-de-memorias.s3.amazonaws.com';

export default {
  deleteFile,
  downloadFile,
  uploadFile,
  getFile,
  baseURL,
  awsURL,
};
